import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import { AtNavbarLinkProps } from '../../atoms'
import { Highlight } from '../../atoms/at-tabs/shared/highlight'

export interface MlNavbarDropdownProps {
  title: string
  dropdownLinks: AtNavbarLinkProps[]
}

export const MlMobileNavbarDropdown = ({ title, dropdownLinks }: MlNavbarDropdownProps) => {
  //the library headlessui has a bug that make the Popover enabling :focus-visible state on mouse interaction
  const focusFix = () => {
    requestAnimationFrame(() => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur()
      }
    })
  }

  return (
    <Popover className="relative group" role="navigation">
      {({ open }) => (
        <>
          <PopoverButton
            aria-haspopup="true"
            onClick={focusFix}
            className="text-neutrals-800 group-data-[open]:text-neutrals-900"
          >
            {title}
          </PopoverButton>
          {open && <Highlight className="mt-1 w-full bg-current" />}
          <PopoverPanel className="flex flex-col pl-8 pt-4 gap-4" role="menu">
            {dropdownLinks.map((link, index) => (
              <MobileDropdownLink key={index} {...link} />
            ))}
          </PopoverPanel>
        </>
      )}
    </Popover>
  )
}

const MobileDropdownLink = ({ label, href, onTrackClick, disabled, target }: AtNavbarLinkProps) => {
  return (
    <div className="h-10">
      <a
        className="font-regular text-14 leading-[1.3rem] text-neutrals-800 hover:text-neutrals-900"
        onClick={(event) => {
          if (onTrackClick) onTrackClick(event)
        }}
        href={!disabled ? href : undefined}
        target={target}
        aria-disabled={disabled}
        role="menuitem"
      >
        {label}
      </a>
    </div>
  )
}
